export const sanitiseKey = (key: string | number) => {
  return key
    .toString()
    .trim()
    .replace(/[^a-zA-Z0-9]/g, '_')
    .replace(/_+/g, '_') // Replace multiple consecutive underscores with a single one
    .toUpperCase();
};
